module.exports = __webpack_public_path__ + "img/john-hooker.1cf62c38.png";